
import React, { useEffect, useRef, useState } from "react";
import sia from "../services/Api";
import Cookies from "js-cookie";
// import {useLoginDispatch} from "../hooks";
import logo from '../assets/images/logo.svg';
import setHeaderForAxios from "./../services/Api"
import TopNav from "./TopNav";

function SmsEnter() {
    // const loginDispatch = useLoginDispatch();
    // const handeLogin = (e)=>{
    //     e.preventDefault();
    //     // sia.PostDataToServer("/user/sendSms",{"phone":"09150963213","password":"3213"})
    //     sia.PostDataToServer("/user/sendSms",{"phone":"09150963213"})
    //         .then(res=>{
    //             console.log(res);
    //             // Cookies.set("token",res.token);
    //             // loginDispatch(true);
    //             // setHeaderForAxios(res.token);
    //         })
    //         .catch(err=>{
    //             console.log(err)
    //         })
    //
    // }
    return(


        <>


            <div>
                <button onClick={handeLogin}>login</button>
            </div>

            <div className="pagewrapper" id="login-page">
                <div className="blur">
                    <div className="container">
                        <TopNav />
                        <div className="content">
                            <div className="login-wrapper radius50 box-sizing">
                                <form action id="login-form" method="post">
                                    <p className="text">لطفارمز ورود را وارد کنید:</p>
                                    <input type="text" name="mobile" placeholder="09*********" className="login-mobile input radius50" />
                                    <input type="submit" onClick={handeLogin} Value="ارسال" className="login-btn radius50" />
                                </form>
                            </div>
                        </div>
                        <div className="top-section-bullets">
                            <a href title className="item ease box-sizing" />
                            <a href title className="item selected ease box-sizing" />
                            <a href title className="item ease box-sizing" />
                            <a href title className="item ease box-sizing" />
                        </div>
                        <div className="clear" />
                    </div>
                </div>
            </div>
        </>
    )

}
export default SmsEnter